<template>
    <div class="my-input" :class="{ 'is-focus ': showFocusMode, ' input-group ': hasAppendSlot }">
        <input
            v-model="current_value"
            ref="input"
            :name="name"
            :type="type"
            class="form-control"
            :class="additionalClass"
            :placeholder="current_placeholder"
            @input="onInput"
            @focus="onFocus"
            @blur="onBlur"
   
            :disabled="disabled"
            :readonly="readonly"
            :maxlength="maxlength"
            :max="max"
            :min="min"
            v-on="listeners"
            :autocomplete="autocomplete_value"
        >
        <div class="input-group-append" v-show="hasAppendSlot">
            <span class="input-group-text">
                <slot name="append"></slot>
            </span>
        </div>
        
        <div
            class="my-input-label"
            @click="$refs.input.focus()"
        >
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        additionalClass: {
            type: String,
            required: false,
        },
        
        autocomplete: {
            type: Boolean,
            required: false,
        },

        autofocus: {
            type: Boolean,
            required: false,
        },

        secondary: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        label: {
            type: String,
            required: false,
        },

        max: {
            type: String,
            default: null,
        },

        maxlength: {
            type: String,
            default: null,
        },

        min: {
            type: String,
            default: null,
        },

        name: {
            type: String,
            required: false,
        },

        placeholder: {
            type: String,
            required: false,
        },

        readonly: {
            type: Boolean,
            default: false,
        },

        type: {
            type: String,
            default: 'text',
        },

        value: {
            type: [ String, Number ],
            required: false,
        },
    },

    data() {
        return {
            current_placeholder: this.placeholder,
            is_focus: false,
            current_value: this.value,
        }
    },

    computed: {
        showFocusMode() {
            return this.is_focus || this.current_value || this.placeholder
        },

        hasAppendSlot() {
            return !!this.$slots.append
        },

        hasValue() {
            return this.current_value != ''
                && this.current_value != null
                && this.current_value != undefined
                && this.current_value
        },
        /*
            con questa computed tutti i lister applicati dall'esterno
            sulla my-input vengono riversati sulla input
        */
        listeners() {
            return {
                ...this.$listeners,
                input: event => this.onInput,
                focus: event => this.onFocus,
                blur: event => this.onBlur
            }
        },

        autocomplete_value() {
            return !this.autocomplete ? 'off' : 'new-password'
        }
    },

    watch: {
        placeholder() {
            this.current_value = ''

            this.current_placeholder = this.placeholder
        },

        value(newValue) {
            this.current_value = newValue
        },

        is_focus(newValue) {
            if(!newValue && this.current_placeholder == '')
            {
                this.current_placeholder = this.placeholder
            }
        }
    },

    methods: {
        checkFocus() {
            if(! this.current_value) {
                this.is_focus = false
            }
        },

        onBlur() {
            this.is_focus = false

            this.$emit('blur')
        },

        onFocus() {
            this.is_focus = true
            this.current_placeholder = ''

            this.$emit('focus')
        },

        onInput() {
            this.checkFocus()

            this.$emit('input', this.current_value)
        },

        setFocus() {
            this.$refs.input.focus()
        },

    },

    mounted() {
        if (this.autofocus) {
            this.$nextTick(() => this.$refs.input.focus())
        }
    }
}
</script>

<style lang="sass" scoped>
    .my-input
        position: relative

        .my-input-label
            position: absolute
            top: .8rem
            left: 0
            margin-left: .75rem
            color: grey
            transition: all .2s

        &.is-focus
            input
                padding-top: 1.3rem

            .my-input-label
                top: 0.5rem
                font-size: 0.75rem
                height: auto
                line-height: 1
                z-index: 3
        
        .input-group-text
            border-top-right-radius: 10px!important
            border-bottom-right-radius: 10px!important

</style>